import _ from 'lodash';
import { Moment } from 'moment';
import React from 'react';
import { GoodTable } from '@good/ui/templates';

import { DayColumn } from './DayColumn';
import { OpenSlotsDetailsColumn } from './open-slots-details-column';
import { IRosterShift } from '../../types';
import { OpenSlotsList } from './open-slots-list';

interface OpenSlotsRowProps {
  openShifts?: IRosterShift[];
  days: Moment[];
}

export function OpenSlotsRow({ openShifts, days }: OpenSlotsRowProps) {
  const numberOfSlots = _.size(openShifts);

  return (
    <GoodTable.Tr>
      <GoodTable.Td sticky bg='gray.0'>
        <OpenSlotsDetailsColumn numberOfSlots={numberOfSlots} />
      </GoodTable.Td>

      {_.map(days, (day, idx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <GoodTable.Td key={idx}>
          <DayColumn content={<OpenSlotsList day={day} shifts={openShifts} />} />
        </GoodTable.Td>
      ))}
    </GoodTable.Tr>
  );
}
